var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"icon":"","small":""},on:{"click":_vm.handleInput}},[_c('v-icon',{staticClass:"ma-0 pa-0",attrs:{"size":24,"color":_vm.value ? 'accent' : 'grey darken-1'}},[_vm._v(_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }